<div class="flex flex-col flex-1 bg-container">
  <div
    [ngClass]="{
      'flex-row': PLATFORM === PlatformType.DESKTOP,
      'flex-col': PLATFORM === PlatformType.MOBILE
    }"
    class="flex flex-1 gap-2"
  >
    @if (!hideSidebar) {
      <div
        [ngClass]="{
          'mt-2 mb-2 ml-2 flex-0-270': PLATFORM === PlatformType.DESKTOP,
          'mx-2': PLATFORM === PlatformType.MOBILE
        }"
        class="relative flex flex-col gap-2 bg-container"
      >
        <!-- emoji & actions -->
        <div class="absolute top-0 left-0 right-0 flex flex-row">
          <div class="flex flex-row">
            @if (emojiConfig) {
              <div
                emojiPicker
                #picker="emojiPicker"
                (click)="picker.open()"
                (emoji)="emojiConfig.add.emit($event)"
                class="flex flex-row items-center p-1 px-2 transition-colors rounded-md cursor-pointer hover:bg-slate-100"
              >
                <span class="text-slate-600">
                  <i class="fa-light fa-face-smile-plus"></i>
                </span>
              </div>
            }
            <!-- widget under title -->
            @if (widgetsTopLeft && widgetsTopLeft.length > 0) {
              <div class="flex flex-col gap-2">
                @for (widget of widgetsTopLeft; track widget) {
                  <ng-container
                    [ngTemplateOutlet]="widget.templateRef"
                  ></ng-container>
                }
              </div>
            }
          </div>

          <div class="flex flex-row items-center gap-1 ml-auto">
            @for (action of headerActions; track action) {
              <ng-container
                [ngTemplateOutlet]="actionTemplate"
                [ngTemplateOutletContext]="{
                  $implicit: action,
                  deleted: deleted()
                }"
              ></ng-container>
            }
          </div>
        </div>

        <!-- image or icon, title and header lines -->
        <div id="snt-page-detail-header" class="flex flex-col gap-0">
          <!-- image or icon -->
          <div class="flex items-center justify-center">
            <div
              class="relative"
              [ngStyle]="{
                height: !!icon() ? '48px' : '92px',
                width: !!icon() ? '48px' : '92px'
              }"
            >
              @if (imageSrc()) {
                <div
                  class="absolute inset-0 flex items-center justify-center p-2 overflow-hidden"
                >
                  <img
                    #img
                    crossorigin
                    [src]="imageSrc()"
                    (error)="img.src = '/assets/images/fallback/facility.png'"
                    [ngStyle]="{
                      border: color ? '6px solid' : null,
                      'border-color': color || null,
                      'border-radius': color ? '10000px' : null
                    }"
                    class="rounded-full h-full"
                  />
                </div>
              }

              @if (icon()) {
                <div class="absolute inset-0 flex items-center justify-center">
                  <i class="{{ icon() }} text-4xl"></i>
                </div>
              }

              <input
                #fileImagePicker
                (change)="onImageFilePickerChange()"
                type="file"
                accept="image/*"
                class="hidden"
              />

              @if (detailImage?.first?.allowEdit) {
                <div
                  (click)="onImageFilePickerOpen()"
                  class="absolute inset-0 flex items-center justify-center transition-opacity rounded-full opacity-0 cursor-pointer bg-slate-400 hover:opacity-75"
                >
                  <i class="fa-light fa-image fa-2x"></i>
                </div>
              }

              @if (locked) {
                <div
                  class="absolute bottom-0 right-0 flex items-center justify-center w-6 h-6 rounded-full shadow-md bg-slate-400"
                  [sntTooltip]="'Read only' | transloco"
                >
                  <i class="text-xs text-white fa-light fa-lock"></i>
                </div>
              }

              @if (secondaryImage) {
                <div
                  class="absolute bottom-0 right-0 flex items-center justify-center w-6 h-6 rounded-full shadow-md bg-slate-400"
                >
                  <img
                    crossorigin
                    [src]="secondaryImage"
                    class="w-6 h-6 rounded-full"
                  />
                </div>
              }

              @if (secondaryIcon) {
                <div
                  class="absolute bottom-0 right-0 flex items-center justify-center w-6 h-6 rounded-full shadow-md"
                  [ngClass]="secondaryIconColor || 'bg-slate-400'"
                >
                  <i
                    class="text-xs text-white rounded-full"
                    [ngClass]="secondaryIcon"
                  ></i>
                </div>
              }
            </div>
          </div>

          <!-- title and header lines -->
          @if (
            !!title ||
            (header?.first?.headerLinks?.length || 0) > 0 ||
            (header?.first?.headerLines?.length || 0) > 0 ||
            (lines?.length || 0) > 0 ||
            (header?.first?.headerBadges?.length || 0) > 0
          ) {
            <div class="flex flex-col gap-2">
              <div class="flex flex-col">
                @if (preTitle) {
                  <div class="flex flex-row justify-center">
                    <span class="text-sm text-slate-600">{{ preTitle }}</span>
                  </div>
                }

                @if (title || titleIcon) {
                  <div class="flex flex-row items-center justify-center gap-2">
                    @if (titleIcon) {
                      <i class="{{ titleIcon }} text-xl"></i>
                    }
                    <span
                      class="text-xl text-center text-primary-900"
                      [ngClass]="{
                        'line-through decoration-slate-400': deleted()
                      }"
                      >{{ title }}</span
                    >
                  </div>
                }
              </div>

              <!-- deleted -->
              @if (deleted()) {
                <div class="flex items-center justify-center">
                  <div
                    class="flex flex-row items-center gap-4 px-4 py-2 rounded-md bg-slate-200"
                  >
                    <i class="text-xl fa-light fa-trash-can text-slate-400"></i>
                    <div class="flex flex-col gap-0">
                      <span class="text-base text-slate-900">
                        {{
                          deletedIsFemale()
                            ? ("Eliminata" | transloco)
                            : ("Eliminato" | transloco)
                        }}
                      </span>
                      @if (dateOfDeletion()) {
                        <span class="text-sm text-slate-400">
                          {{ dateOfDeletion() | dayjs }}
                        </span>
                      }
                    </div>
                  </div>
                </div>
              }

              <!-- widget under title -->
              @if (widgetsUnderTitle && widgetsUnderTitle.length > 0) {
                <div class="flex flex-col gap-2">
                  @for (widget of widgetsUnderTitle; track widget) {
                    <ng-container
                      [ngTemplateOutlet]="widget.templateRef"
                    ></ng-container>
                  }
                </div>
              }

              @if (subHeader && subHeader.length > 0) {
                <div class="flex flex-col items-center justify-center gap-1">
                  @for (headerItem of subHeader; track headerItem) {
                    <span class="text-xl text-center text-slate-700">{{
                      headerItem
                    }}</span>
                  }
                </div>
              }

              @for (
                link of header?.first?.headerLinks;
                track link;
                let isLast = $last
              ) {
                <a [routerLink]="link.href">
                  <div
                    [ngClass]="{ 'mr-2': !isLast }"
                    class="py-1 px-1 inline-block rounded-md overflow-hidden whitespace-nowrap text-ellipsis text-slate-800 transition-colors bg-slate-200 hover:bg-slate-300"
                  >
                    {{ link.text }}
                  </div>
                </a>
              }

              <!--header lines, mobile actions-->
              <div class="flex flex-row gap-2">
                @if (
                  (!!header?.first?.headerLines &&
                    (header?.first?.headerLines?.length || 0) > 0) ||
                  (!!lines && lines.length > 0)
                ) {
                  <div
                    class="flex-1 flex flex-col gap-1 bg-white p-2 rounded-md"
                  >
                    @if (header?.first?.headerLines) {
                      @for (line of header?.first?.headerLines; track line) {
                        <div
                          class="flex flex-row items-center"
                          [ngClass]="{
                            'gap-2': line.lines && line.lines.length > 0,
                            'gap-1': !line.lines || line.lines.length === 0
                          }"
                        >
                          @if (line.lines && line.lines.length > 0) {
                            @for (subLine of line.lines; track subLine) {
                              <div class="flex flex-row gap-1">
                                @if (subLine.icon) {
                                  <div
                                    class="flex items-center justify-center w-3 h-3"
                                  >
                                    <i [class]="subLine.icon"></i>&nbsp;
                                  </div>
                                }
                                @if (subLine.text) {
                                  <span class="text-xs text-slate-600">{{
                                    subLine.text
                                  }}</span>
                                }
                                @if (subLine.html) {
                                  <span
                                    class="text-xs text-slate-600"
                                    [innerHTML]="subLine.html"
                                  ></span>
                                }
                              </div>
                            }
                          }
                          @if (!line.lines || line.lines.length === 0) {
                            @if (line.icon) {
                              <div
                                class="flex items-center justify-center w-3 h-3"
                              >
                                <i [class]="`${line.icon} text-primary-900`"></i
                                >&nbsp;
                              </div>
                            }
                            @if (line.text) {
                              <span class="text-xs text-primary-900">
                                @if (line.mailto) {
                                  <snt-mailto
                                    [mail]="line.text"
                                    [hrefClass]="'[&:not(:hover)]:text-primary-900'"
                                  ></snt-mailto>
                                } @else {
                                  {{ line.text }}
                                }
                              </span>
                            }
                            @if (line.html) {
                              <span
                                class="text-xs text-slate-600"
                                [innerHTML]="line.html"
                              ></span>
                            }
                          }
                        </div>
                      }
                    }

                    @for (line of lines; track line) {
                      <span class="text-sm text-slate-700">
                        {{ line }}
                      </span>
                    }
                  </div>
                }

                @if (PLATFORM === PlatformType.MOBILE) {
                  <div
                    class="ml-auto flex flex-row gap-1 items-center justify-center rounded-md bg-white p-2"
                    (click)="dxActionSheetActions.visible = true"
                  >
                    <span class="text-slate-900 text-xs">
                      {{ "Azioni" | transloco }}
                    </span>

                    <i class="fa-light fa-chevron-down"></i>
                  </div>

                  <dx-action-sheet
                    #dxActionSheetActions
                    [items]="dxActionSheetItemsActions()"
                    [showTitle]="false"
                    [visible]="false"
                  ></dx-action-sheet>
                }
              </div>

              @if (
                header?.first?.headerBadges &&
                (header?.first?.headerBadges?.length || 0) > 0
              ) {
                <div class="flex flex-row">
                  @for (
                    badge of header?.first?.headerBadges;
                    track badge;
                    let isLast = $last
                  ) {
                    <div
                      [ngClass]="{ 'mr-2': !isLast }"
                      class="p-1 bg-slate-100 transition-colors hover:bg-slate-300 cursor-pointer rounded-md flex items-center"
                      (click)="badge.onClick.emit()"
                    >
                      <span class="text-slate-800">
                        {{ badge.title }}
                      </span>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>

        <!-- icons -->
        @if (!!icons && icons.length > 0) {
          <div class="flex flex-row items-center justify-center gap-2">
            @for (icon of icons; track $index) {
              <i class="{{ icon.icon }}"></i>
            }
          </div>
        }

        <div id="snt-page-detail-sub-header" class="flex flex-col gap-2">
          <!-- snt tags -->
          @if (sntTags && sntTags.length > 0) {
            <div
              class="flex flex-row items-center justify-center gap-2 flex-wrap"
            >
              @for (tag of sntTags; track $index) {
                @switch (tag.type) {
                  @case ("default") {
                    <snt-tag
                      [image]="tag.image"
                      [icon]="tag.icon"
                      [name]="tag.title"
                      [color]="COLORS.TAUPE"
                      (click)="tag.onClick.emit()"
                    ></snt-tag>
                  }

                  @case ("warning") {
                    <snt-tag
                      [image]="tag.image"
                      [icon]="tag.icon"
                      [name]="tag.title"
                      [color]="COLORS.RED_ORANGE"
                      (click)="tag.onClick.emit()"
                    ></snt-tag>
                  }

                  @case ("error") {
                    <snt-tag
                      [image]="tag.image"
                      [icon]="tag.icon"
                      [name]="tag.title"
                      [color]="COLORS.VIVID_RED"
                      (click)="tag.onClick.emit()"
                    ></snt-tag>
                  }

                  @case ("success") {
                    <snt-tag
                      [image]="tag.image"
                      [icon]="tag.icon"
                      [name]="tag.title"
                      [color]="COLORS.FOREST_GREEN"
                      (click)="tag.onClick.emit()"
                    ></snt-tag>
                  }

                  @case ("info") {
                    <snt-tag
                      [image]="tag.image"
                      [icon]="tag.icon"
                      [name]="tag.title"
                      [color]="COLORS.INDIGO_BLUE"
                      (click)="tag.onClick.emit()"
                    ></snt-tag>
                  }
                }
              }
            </div>
          }

          <!-- widget top -->
          @if (widgetsTop && widgetsTop.length > 0) {
            <div class="flex flex-col gap-2">
              @for (widget of widgetsTop; track widget) {
                <ng-container
                  [ngTemplateOutlet]="widget.templateRef"
                ></ng-container>
              }
            </div>
          }

          <!-- action -->
          @if (
            PLATFORM === PlatformType.DESKTOP &&
            actionsLocation === "leftShoulder" &&
            !!sntActions &&
            sntActions.length > 0
          ) {
            <div class="flex flex-col gap-2">
              @for (action of sntActions; track $index) {
                @let actionComponent = asActionComponent(action);

                @if (!action.isSeparator && !action.isGroup) {
                  <snt-button
                    [layout]="'default'"
                    [icon]="actionComponent.icon!"
                    [title]="actionComponent.title!"
                    [disabled]="deleted() || actionComponent.disabled"
                    [sntTooltip]="actionComponent.tooltip"
                    [type]="undefined"
                    (onClick)="actionComponent.do.emit()"
                    (onClickAsync)="actionComponent.onDoAsync($event)"
                  ></snt-button>
                }

                @if (action.isSeparator) {
                  <div class="h-px bg-slate-100"></div>
                }

                @if (action.isGroup) {
                  <div class="flex flex-1 mt-2">
                    <div class="flex flex-1 flex-row gap-1">
                      <span class="text-xs uppercase text-primary-900">{{
                        asActionGroup(action).label
                      }}</span>

                      <div class="flex items-center flex-1">
                        <div class="flex-1 h-px bg-primary-900"></div>
                      </div>
                    </div>
                  </div>
                }
              }
            </div>
          }

          <!-- tags -->
          @if (!!tags && tags.length > 0) {
            <div class="h-px bg-slate-100"></div>

            <div class="flex flex-col gap-2">
              @for (tag of tags; track $index) {
                <div
                  class="rounded-full p-2 flex items-center justify-center cursor-pointer opacity-50 hover:opacity-100 transition-opacity {{
                    tag.color
                  }}"
                >
                  <span class="text-base opacity-100 {{ tag.textColor }}">{{
                    tag.title
                  }}</span>
                </div>
              }
            </div>
          }

          <!-- integration properties -->
          @let _integrationProperties = integrationProperties();
          @if (_integrationProperties.length > 0) {
            @for (integration of _integrationProperties; track $index) {
              <div class="h-px bg-slate-100"></div>

              <div class="flex flex-col gap-2">
                <div class="flex flex-row items-center gap-1">
                  <div>
                    <img
                      [src]="integration.installation.integration.icon"
                      crossOrigin
                      class="h-4 w-4"
                    />
                  </div>

                  <div>
                    <span class="uppercase text-xxs text-slate-400">
                      {{ integration.installation.integration.name }}
                    </span>
                  </div>
                </div>

                <div class="flex flex-col gap-2">
                  @for (property of integration.properties; track $index) {
                    <snt-editable
                      [value]="property.value"
                      [label]="property.label"
                      [dataType]="property.dataType"
                      [icon]="property.icon"
                      [enabled]="false"
                      [showLabelBottomBorder]="true"
                      [labelSmall]="true"
                      [labelLight]="true"
                      class="flex-1"
                    ></snt-editable>
                  }
                </div>
              </div>
            }
          }

          <!-- widgets middle -->
          @if (widgetsMiddle && widgetsMiddle.length > 0) {
            <div class="flex flex-col gap-2">
              <div class="flex flex-col gap-2">
                @for (widget of widgetsMiddle; track $index) {
                  <ng-container
                    [ngTemplateOutlet]="widget.templateRef"
                  ></ng-container>
                }
              </div>
            </div>
          }

          <!-- widget bottom -->
          @if (!!widgetsBottom && widgetsBottom.length > 0) {
            <div class="flex flex-col gap-2">
              @for (widget of widgetsBottom; track widget) {
                <ng-container
                  [ngTemplateOutlet]="widget.templateRef"
                ></ng-container>
              }
            </div>
          }
        </div>
      </div>
    }

    <div
      [ngClass]="{
        'mt-2 mr-2 mb-2': PLATFORM === PlatformType.DESKTOP,
        'mx-2': PLATFORM === PlatformType.MOBILE
      }"
      class="flex-1 flex flex-col gap-2 bg-container {{
        hideSidebar ? 'ml-2' : ''
      }} rounded-md"
    >
      <!-- warnings -->
      @let _warnings = warnings();

      @if (_warnings.length > 0) {
        <div class="flex flex-col gap-1">
          @for (warning of _warnings; track $index) {
            <div
              class="flex flex-row items-center gap-6 px-4 py-2 bg-orange-200 border-orange-500 rounded-md"
            >
              <div class="flex flex-row items-center gap-2">
                <div class="flex items-center justify-center w-6 h-6">
                  <i class="{{ warning.icon }} text-orange-500"></i>
                </div>
                @if (warning.message) {
                  <span class="text-sm font-medium text-orange-500">{{
                    warning.message
                  }}</span>
                }
              </div>
              @if (warning.link) {
                <span class="text-sm font-medium text-orange-500">
                  <a
                    href="{{ warning.link }}"
                    target="_blank"
                    class="text-sm font-bold text-orange-500 underline"
                    >{{ warning.linkText }}</a
                  >
                </span>
              }
            </div>
          }
        </div>
      }

      @let _actionGroups = actionsGroups();
      @let _toolbarIntegrations = toolbarIntegrations();

      @if (
        (PLATFORM === PlatformType.DESKTOP &&
          actionsLocation === "toolbar" &&
          (_actionGroups.length > 0 || _toolbarIntegrations.length > 0)) ||
        laikaCanActivated
      ) {
        <div
          class="flex-wrap flex flex-row gap-0 bg-white p-2 rounded-md"
          id="snt-page-detail-toolbar-actions"
        >
          @for (group of _actionGroups; track $index) {
            <div class="flex flex-col gap-1">
              <div>
                <span class="text-xs text-slate-400">{{
                  group.title || "&nbsp;"
                }}</span>
              </div>

              <div class="flex-1 flex flex-row gap-x-0 gap-y-0">
                @if (!$first) {
                  <div class="w-px my-4 bg-slate-200 mr-2"></div>
                }

                @for (action of group.actions; track $index) {
                  <snt-button
                    [layout]="'ribbon'"
                    [icon]="action.icon"
                    [title]="action.title"
                    [disabled]="deleted() || action.disabled"
                    [type]="'primary-outlined'"
                    [small]="true"
                    class="flex-1"
                    (onClick)="action.do.emit()"
                    (onClickAsync)="action.doAsync.emit($event)"
                  ></snt-button>
                }
              </div>
            </div>
          }

          @if (_toolbarIntegrations.length > 0) {
            @for (
              toolbarIntegrationItem of _toolbarIntegrations;
              track $index
            ) {
              <div class="flex flex-col gap-1">
                <div class="flex flex-row items-center gap-1">
                  <div>
                    <img
                      [src]="toolbarIntegrationItem.icon"
                      crossOrigin
                      class="h-4 w-4"
                    />
                  </div>
                  <div>
                    <span class="text-xs text-slate-400">
                      {{ toolbarIntegrationItem.title }}</span
                    >
                  </div>
                </div>

                <div class="flex-1 flex flex-row gap-x-2 gap-y-0">
                  @if (!$first || _actionGroups.length > 0) {
                    <div class="w-px my-4 bg-slate-200"></div>
                  }

                  @for (
                    actionRendered of toolbarIntegrationItem.actionsRendered;
                    track $index
                  ) {
                    @let _rendered = actionRendered.rendered;
                    <snt-button
                      [layout]="'ribbon'"
                      [icon]="_rendered.icon"
                      [title]="_rendered.label"
                      [disabled]="deleted() || _rendered.disabled"
                      [type]="'primary-outlined'"
                      [small]="true"
                      class="flex-1"
                      (onClickAsync)="
                        toolbarIntegrationItemOnClickAsync(
                          $event,
                          actionRendered.action
                        )
                      "
                    ></snt-button>
                  }
                </div>
              </div>
            }
          }

          @if (laikaCanActivated) {
            <div class="flex flex-col gap-1 ml-4">
              <div class="flex flex-row items-center gap-1">
                <div>
                  <img
                    [src]="'/assets/images/integrations/laika-ai/logo.png'"
                    crossOrigin
                    class="h-4 w-4"
                  />
                </div>
                <div>
                  <span class="text-xs text-slate-400"> {{ "Laika AI" }}</span>
                </div>
              </div>

              <div class="flex-1 flex flex-row gap-x-2 gap-y-0">
                <div class="w-px my-4 bg-slate-200"></div>

                <snt-button
                  [layout]="'ribbon'"
                  [icon]="'fa-light fa-sparkles'"
                  [title]="'Parla con Laika' | transloco"
                  [disabled]="false"
                  [type]="'primary-outlined'"
                  [small]="true"
                  class="flex-1"
                  (onClickAsync)="onActivateLaika($event)"
                ></snt-button>
              </div>
            </div>
          }
        </div>
      }

      <div
        id="snt-page-detail-content"
        class="relative flex flex-col gap-1 flex-1"
      >
        @let _selectedTabIndex = selectedTabIndex();
        @let _selectedTab = selectedTab();

        @if (hasContent()) {
          <div class="flex-1 flex bg-content rounded-md p-2">
            <ng-container
              [ngTemplateOutlet]="content()!.template()!.templateRef"
            ></ng-container>
          </div>
        } @else {
          <!-- tab header -->
          @switch (PLATFORM) {
            @case (PlatformType.MOBILE) {
              <div
                class="flex flex-row items-center justify-center gap-1 p-2 rounded-t-md bg-content"
                (click)="dxActionSheetTabs.visible = true"
              >
                <div>
                  <i class="{{ _selectedTab?.icon }}"></i>
                </div>

                <span class="text-slate-900 text-xs font-medium">{{
                  _selectedTab?.title
                }}</span>

                <div class="ml-1">
                  <i class="fa-light fa-chevron-down"></i>
                </div>
              </div>

              <dx-action-sheet
                #dxActionSheetTabs
                [items]="dxActionSheetItemsTabs()"
                [showTitle]="false"
                [visible]="false"
                (onItemClick)="onActionSheetTabsItemClick($event)"
              ></dx-action-sheet>
            }
            @case (PlatformType.DESKTOP) {
              @let _tabs = tabs();

              <div
                [overflowDetector]="{
                  disabled: PLATFORM !== PlatformType.DESKTOP,
                  itemsCount: tabs().length || 0,
                  itemsSize: 24 + 100 + 8
                }"
                class="flex flex-row flex-wrap gap-x-6 gap-y-2 pr-2"
                (overflow)="onTabOverflow()"
                (inside)="onTabInside()"
              >
                @for (tab of _tabs; track $index) {
                  <div
                    class="flex flex-col transition-colors select-none bg-container h-10"
                    (click)="!tab.disabled && onTabClick($index, tab.name)"
                  >
                    <!-- tab content -->
                    <div
                      class="flex flex-row gap-1 items-center flex-1 px-2 relative overflow-hidden"
                      [ngClass]="{
                        'text-primary-900 bg-white rounded-md':
                          _selectedTabIndex === $index,
                        'text-slate-400': _selectedTabIndex !== $index,
                        'cursor-not-allowed': tab.disabled,
                        'cursor-pointer': !tab.disabled,
                        'text-slate-200': tab.disabled
                      }"
                    >
                      @if (_selectedTabIndex === $index) {
                        <div
                          class="absolute bottom-0 left-0 right-0 h-1 bg-primary-900"
                        ></div>
                      }

                      <!-- icon -->
                      <div>
                        <i class="{{ tab.icon }}"> </i>
                      </div>

                      <!-- title -->
                      <div class="text-ellipsis whitespace-nowrap">
                        <span class="text-xs"> {{ tab.title }}</span>
                      </div>

                      @if (tab.notifyNewContentName) {
                        <snt-notify-new-content
                          [name]="tab.notifyNewContentName"
                          [small]="true"
                          [hideText]="true"
                          class="self-center"
                        ></snt-notify-new-content>
                      }

                      <!-- volatile badge, badge -->
                      @if (
                        (tab.name && volatileBadges[tab.name]) ||
                        (tab.badge && tab.badge > 0) ||
                        (tab.payAttentionWarning &&
                          tab.payAttentionWarning.length > 0)
                      ) {
                        <div class="flex flex-row items-center gap-1">
                          <!-- volatile badge -->
                          @if (tab.name && volatileBadges[tab.name]) {
                            <div class="flex items-center justify-center">
                              <div
                                class="flex items-center justify-center w-3 h-3 transition-transform bg-primary-600 rounded-full"
                              ></div>
                            </div>
                          }

                          <!-- badge -->
                          @if (tab.badge && tab.badge > 0) {
                            <div class="flex items-center justify-center">
                              <div
                                class="flex items-center justify-center w-5 h-5 rounded-full bg-slate-200"
                              >
                                <span class="text-[10px] text-slate-600">
                                  {{ tab.badge }}
                                </span>
                              </div>
                            </div>
                          }

                          @if (
                            tab.payAttentionWarning &&
                            tab.payAttentionWarning.length > 0
                          ) {
                            <div class="flex items-center justify-center">
                              <div
                                class="flex items-center justify-center w-2 h-2 rounded-full bg-orange-500"
                                [sntTooltip]="tab.payAttentionWarning"
                              ></div>
                            </div>
                          }
                        </div>
                      }
                    </div>

                    <!--
                    <div
                      class="h-0.5 transition-colors"
                      [ngClass]="{
                        'bg-container': _selectedTabIndex !== $index,
                        'bg-primary-900': _selectedTabIndex === $index
                      }"
                    ></div>
                  --></div>
                }
              </div>
            }
          }

          <!-- tab content -->
          <div
            [ngClass]="{ relative: PLATFORM === PlatformType.DESKTOP }"
            class="flex flex-1"
          >
            <div
              [ngClass]="{
                'flex-1': PLATFORM === PlatformType.MOBILE,
                'absolute inset-0 rounded-tr-md':
                  PLATFORM === PlatformType.DESKTOP,
                'rounded-tl-md':
                  _selectedTabIndex > 0 && PLATFORM === PlatformType.DESKTOP,
                'py-2':
                  PLATFORM === PlatformType.DESKTOP &&
                  !_selectedTab?.noContentPadding,
                'px-2': !_selectedTab?.noContentPadding
              }"
              class="flex overflow-auto bg-content rounded-b-md"
            >
              <ng-container
                *ngTemplateOutlet="selectedTabTemplate()!"
              ></ng-container>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #actionTemplate let-action let-deleted="deleted">
  <snt-button-icon
    [icon]="action.icon"
    [title]="action.title"
    [disabled]="deleted || action.disabled"
    [size]="'xs'"
    (onClick)="onHeaderActionClick(action)"
  ></snt-button-icon>
</ng-template>
